export default {"src":"/_next/static/media/spin.c4626fe5.svg","height":35,"width":35};